import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";

export default function Timeline() {
    const { data } = useContext(ContentContext);
    const t = data.timeline;
    if (!t || !t.items) return null;

    return (
        <section className="relative py-20 md:py-28 bg-navy-50 overflow-hidden">
            <div className="absolute inset-0 brand-pattern opacity-30 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <div className="max-w-2xl mb-12">
                    <div className="inline-flex items-center gap-3 mb-4">
                        <span className="h-px w-10 bg-gold-500" />
                        <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                            {t.eyebrow}
                        </span>
                    </div>
                    <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy-900 mb-4 leading-tight">
                        {t.title}
                    </h2>
                    <p className="text-lg text-navy-700/85 leading-relaxed">{t.subtitle}</p>
                </div>

                <ol className="relative border-l-2 border-brand-leaf/50 ps-6 space-y-8">
                    {t.items.map((m, i) => (
                        <li key={i} className="relative">
                            <span className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-gold-400 border-4 border-white shadow-soft" />
                            <div className="font-serif text-2xl font-bold text-brand-emerald">{m.year}</div>
                            <div className="font-serif text-lg font-bold text-navy-900 mt-1">{m.title}</div>
                            <p className="text-sm text-navy-700/85 leading-relaxed mt-1 max-w-2xl">{m.desc}</p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
